import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { lazy, Suspense, useEffect } from 'react'
import { LoadingState } from './components/LoadingState'
import { rememberBrowseLocation } from './lib/contextualNavigation'
import { ProfileCompletionGate } from './components/ProfileCompletionGate'

const AccountRemovedPage = lazy(() => import('./pages/AccountRemovedPage').then((module) => ({ default: module.AccountRemovedPage })))
const MapPage = lazy(() => import('./pages/MapPage').then((module) => ({ default: module.MapPage })))
const LoginPage = lazy(() => import('./pages/LoginPage').then((module) => ({ default: module.LoginPage })))
const ProfilePage = lazy(() => import('./pages/ProfilePage').then((module) => ({ default: module.ProfilePage })))
const AdminPage = lazy(() => import('./pages/AdminPage').then((module) => ({ default: module.AdminPage })))
const ProfileCompletionPage = lazy(() => import('./pages/ProfileCompletionPage').then((module) => ({ default: module.ProfileCompletionPage })))

function ScrollToTop() {
  const { pathname, search, hash } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  useEffect(() => {
    rememberBrowseLocation({ pathname, search, hash })
  }, [hash, pathname, search])
  return null
}

function LegacyCityRedirect() {
  const { search, hash } = useLocation()
  const params = new URLSearchParams(search)
  for (const key of [...params.keys()]) if (!['punto', 'aggiungi'].includes(key)) params.delete(key)
  return <Navigate to={{ pathname: '/', search: params.toString() ? `?${params}` : '', hash: hash.startsWith('#comment-') ? hash : '' }} replace />
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<LoadingState label="Carico H24 Map Italia…" />}>
        <ProfileCompletionGate><Routes>
          <Route path="/" element={<MapPage />} />
          <Route path="/citta/*" element={<LegacyCityRedirect />} />
          <Route path="/account-rimosso" element={<AccountRemovedPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/profilo" element={<ProfilePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/completa-profilo" element={<ProfileCompletionPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes></ProfileCompletionGate>
      </Suspense>
    </>
  )
}
